import React from "react";
import { CardHeader, CardTitle } from "@/components/ui/card";

export const CompanyHeader = () => {
  return (
    <CardHeader>
      <CardTitle>Gerenciamento de Empresas</CardTitle>
    </CardHeader>
  );
};